<!-- Иконка скачивания: стрелка вниз с полкой. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M12 3v13M7 11l5 5 5-5"
      :transform="direction === 'up' ? 'translate(0 19) scale(1 -1)' : undefined"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 20h18"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "DownloadIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
    direction: {
      type: String,
      default: "down",
      validator: (value) => ["down", "up"].includes(value),
    },
  },
};
</script>
